<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import Icon from 'next/icon/Icon.vue';
import { useMessageContext } from '../provider.js';

const { contentAttributes } = useMessageContext();

const stage = computed(() =>
  String(
    contentAttributes.value?.wameMediaStage ??
      contentAttributes.value?.wame_media_stage ??
      'bank'
  ).toLowerCase()
);

const isComplete = computed(() => stage.value === 'complete');
const currentLabel = computed(() =>
  isComplete.value ? 'Mídia disponível' : 'Entregando no atendimento'
);
</script>

<template>
  <BaseBubble class="min-w-[220px] border border-[#d5e6df] bg-[#effaf4] px-3 py-2.5 text-[#285247]">
    <div class="flex items-center gap-2.5">
      <span
        class="inline-flex size-[30px] shrink-0 items-center justify-center rounded-full bg-white/70 text-[#2f8f70] ring-1 ring-inset ring-[#2f8f70]/10"
        :class="{ 'bg-[#3a9b78] text-white': isComplete }"
      >
        <Icon
          :icon="isComplete ? 'i-lucide-check' : 'i-lucide-paperclip'"
          class="size-4"
        />
      </span>
      <div class="min-w-0">
        <p class="text-sm font-medium leading-5">Mídia recebida</p>
        <p class="text-xs leading-4 opacity-70">{{ currentLabel }}</p>
      </div>
    </div>

    <div class="mt-1.5 flex justify-between text-[10px] leading-4 opacity-60">
      <span>Recebida no banco</span>
      <span>Atendimento</span>
    </div>
  </BaseBubble>
</template>
